import { render, staticRenderFns } from "./quotation-fields.vue?vue&type=template&id=3716e12f&scoped=true"
import script from "./quotation-fields.vue?vue&type=script&lang=js"
export * from "./quotation-fields.vue?vue&type=script&lang=js"
import style0 from "./quotation-fields.vue?vue&type=style&index=0&id=3716e12f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716e12f",
  null
  
)

export default component.exports